import { Route, Routes } from 'react-router-dom';
import Layout from '@/components/Layout';
import ErrorBoundary from '@/components/ErrorBoundary';
import LandingPage from '@/pages/LandingPage';
import HomePage from '@/pages/HomePage';
import DashboardPage from '@/pages/DashboardPage';
import GameAnalyzerPage from '@/pages/GameAnalyzerPage';
import AboutPage from '@/pages/AboutPage';
import PulsePage from '@/pages/PulsePage';

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route element={<Layout />}>
          {/* Landing page — the new public-facing home */}
          <Route index element={<LandingPage />} />

          {/* Core tools */}
          <Route path="/wrapped" element={<HomePage />} />
          <Route path="/matchup" element={<GameAnalyzerPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />

          {/* Analytics pages */}
          <Route path="/pulse" element={<PulsePage />} />

          {/* Static pages */}
          <Route path="/about" element={<AboutPage />} />

          {/* Legacy redirects — keep old URLs working */}
          <Route path="/game-analyzer" element={<GameAnalyzerPage />} />
          <Route path="/progress" element={<DashboardPage />} />
          <Route path="/progress-tracker" element={<DashboardPage />} />

          {/* Unknown paths fall back to landing */}
          <Route path="*" element={<LandingPage />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
